const keys = {
  autoGeneratedHelper: {
    cell: {
      padPaymentHelper: {
        title: '',
        description:
          '<2>Bank account statement</2> <1></1> Find these numbers on your account statement from your bank or your online account. <1></1> Your <0>transit number</0> is a 5 digits number. <1></1> Your <0>account number</0> is a 7 to 12 digits number. <1></1> <2>Cheque specimen</2> <1></1> The first (5 digits) is your <0>transit number</0>. <1></1> The second set (7-12 digits) is your <0>account number</0>.',
      },
      homeReconstructionCost: {
        title: '',
        description: '$t(baseSegment.helpers.homeReconstructionCost.cells.homeReconstructionCost.description)', // this is a reference to an existing translation key to avoid duplication
      },
      roofType: {
        asphalt: {
          title: 'Asphalt shingles',
          description:
            'Roof is made of asphalt shingles. Commonly black, it is one of the most widely used for roofs in North America.',
        },
        clay: {
          title: 'Clay or Slate tile',
          description:
            'Roof is made of tiles. Mainly made from argile, concrete or stone, tile’s shape can be curved or straight.',
        },
        metal: {
          title: 'Metal',
          description: 'Roof is made of metal such as aluminium, steel, copper and zinc.',
        },
        other: {
          title: 'Other',
          description: 'Any other roof material that is not listed.',
        },
        rubber: {
          title: 'Rubber',
          description:
            'Roof is made of a rubber based material such as Ethylene Propylene Diene Terpolymer (EPDT) or Thermoplastic Polyolefin (TPO).',
        },
        wood: {
          title: 'Wood shingles',
          description: 'Roof is made of wood shingles.',
        },
        tar: {
          title: 'Tar and gravel',
          description:
            'Roof is built from layers alternating between asphalt, tar and gravel. The roof is always flat.',
        },
      },
    },
    title: {
      homeReconstructionCost: 'Home reconstruction cost',
      roofType: 'Roof material type',
    },
  },
};

export default keys;

export type TranslationKeys = typeof keys;
